import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './module/index'
// import store from '../store';
import { createStore } from "@/store";
const store = createStore();
import {
    Message,
} from "element-ui";
import getSimple from "@/constants/simple";
import { getWeixinTicketAsync } from '@/plugins/wxConfig'

Vue.use(VueRouter)

//简易版
getSimple().then(res => {
    if(res.isCustom){
        Vue.prototype.isCustom = res.isCustom
        Vue.prototype.customColor = res.customColor
        Vue.prototype.custom = res.custom
      }else{
        Vue.prototype.isCustom = false
        Vue.prototype.customColor = res.customColor
        Vue.prototype.custom = res.custom
      }
    if (typeof(res) !== "undefined") {
        Vue.prototype.isSimple = res.isSimple
    } else {
        Vue.prototype.isSimple = true
    }
})

const originalPush = VueRouter.prototype.push


VueRouter.prototype.push = function push(location) { 
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})


/**
 * 全局前置守卫
 * @param {Object} to 即将要进入的目标
 * @param {Object} from 当前导航正要离开的路由
 * @param {Function} next 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数
 */
router.beforeEach((to, from, next) => {
    let isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
    Vue.prototype.$NProgress.start();
    window.document.title = to.meta.title || '云知-数字资源平台'
        // console.log(1234);

    if (to.path === '/login' || to.path === '/' || to.path === '/loginNoToken') {

        if (isMobile) {
            if (localStorage.getItem('loginInfo') && localStorage.getItem('token') != 'undefined') {
                // console.log(111);
                // setTimeout(() => {
                next({ path: '/pictureCenterMobile' })
                    // }, 80);
            } else {
                // console.log(222);
                next()
            }
        } else {
            if (store.getters.loginInfo) {
                // Message({
                //   showClose: true,
                //   message: '您已登录，请勿重复登录',
                //   type: 'error'
                // });
                let firstPage = localStorage.getItem('firstPage')
                next({ path: firstPage })
            } else {

                next()
            }
        }
    } //判断是否是login页面 避免死循环
    else if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
        if (store.getters.loginInfo) {
            let powers = store.getters.powers

            if (to.meta.hasOwnProperty("field")) {
                if (powers.indexOf(to.meta.field) !== -1) {

                    next()
                } else {
                    Message({
                        showClose: true,
                        message: '您不能访问该页面',
                        type: 'error'
                    });
                    let firstPage = localStorage.getItem('firstPage')
                    next({ path: firstPage })
                        // next({path:'/'})
                }
            } else {
                next()
            }

        } else {
            // Message({
            //   showClose: true,
            //   message: '尚未登录，请先登录',
            //   type: 'error'
            // });
            // console.log(isMobile)
            if (isMobile) {
                next({ path: '/login' })
            } else {
                // next()
                next({ path: '/login' })
            }

            // next({
            //   path: '/login',
            //   query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            // })
        }
    } else {
        next()
    }


    // if(store.getters.loginInfo){
    // next()
    // }else{

    //   Message({
    //     showClose: true,
    //     message: '错了哦，这是一条错误消息',
    //     type: 'error'
    //   });
    //   next({
    //     path: '/login',
    //     query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //   })
    // }

    //   // 忽略验证的路由
    //   const ignore = ["/big-screen", "/login", "/layout/updatePassword","/layout"];
    //   // 获取本地储存
    //   const user = window.localStorage.getItem("user_office");
    //   if (ignore.includes(to.path)) {
    //       next();
    //       return;
    //   }

    //   // 判断是否第一次登录
    //   // 检测是否登录，未登录即跳转至登录页
    //   if (user) {
    //       const isFirst = JSON.parse(user).loginUserProfileDTO.loginState;
    //       if (isFirst === "1") {
    //           next({
    //               path: "/layout/updatePassword"
    //           });
    //       } else {
    //           next();
    //       }
    //   } else {
    //       next({
    //           path: "/login"
    //       });
    //   }
})

/**
 * 全局后置钩子
 * @param {Object} to 
 * @param {Object} from 
 */
router.afterEach((to, from) => {
    if (to.fullPath.indexOf('mobileUpdate') >= 0 || to.fullPath.indexOf('uploader') >= 0) {
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            let u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                let url = window.location.origin + to.fullPath
                if (window.entryUrl === '' || window.entryUrl === undefined || window.entryUrl === null) {
                    window.entryUrl = url
                }
                // alert(123 + window.entryUrl);
                if (window.entryUrl !== url) {
                    // alert(456 + window.entryUrl);
                    window.entryUrl = url
                    window.location.replace(url)
                } else {
                    getWeixinTicketAsync(window.entryUrl)
                        // setTimeout(() => {
                        //     alert(789 + window.entryUrl);
                        // }, 2000);
                }
            }
        }
    }
    Vue.prototype.$NProgress.done();
    //每次切换页面的时候，让页面滚动到最顶部
    window.scrollTo(0, 0);

});


export function createRouter() {
    return router
}